export default __webpack_public_path__ + "static/media/logo.64bb08d3.png";